function dateFormatDMYLean(date){
    const dateFormat = date.split("-")
    return `${dateFormat[2]}/${dateFormat[1]}/${dateFormat[0]}`
}

export {
    dateFormatDMYLean,
}